export const isDevelopment = () =>
  process.env.REACT_APP_ENVIRONMENT !== "production" &&
  process.env.REACT_APP_ENVIRONMENT !== "shadow";

export default isDevelopment();
